/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { Component, PropTypes } from 'react';
import { Modal, ModalHeader, ModalFooter, Button, Container } from 'src/components/Common/reactstrap/lib';

class ModalSocialNetworkDelete extends React.Component {
  constructor(props) {
    super(props);

    this.deleteSocialNetworkSubmit = this.deleteSocialNetworkSubmit.bind(this);
  }

  deleteSocialNetworkSubmit() {    
    this.props.deleteSocialNetwork(this.props.socialNetworkToDeleteId);
    this.props.close();
  }

  render() {
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}> Отвязать соц. сеть? </ModalHeader>
        <Container>
        </Container>
        <ModalFooter>
          <Button onClick={this.props.close}>Нет</Button><Button color="primary" onClick={this.deleteSocialNetworkSubmit}>Да</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ModalSocialNetworkDelete.propTypes = {
  isOpen:  PropTypes.bool,

  toggle:  PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalSocialNetworkDelete;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalSocialNetworkDelete.jsx
 **/